// Keep wire/storage integers exact while presenting ordinary CNY amounts.
const SCALE = 1000000n;
const MAX_MONEY = 9000000000000000n;
export const CNY_PATTERN = '[0-9]+([.][0-9]{1,6})?';
export const SIGNED_CNY_PATTERN = '-?[0-9]+([.][0-9]{1,6})?';

function fail(code) { throw Object.assign(new Error(code), { code }); }

export function cnyToMicro(value, signed = false) {
  const text = String(value).trim();
  if (!(signed ? /^-?\d+(?:\.\d{1,6})?$/ : /^\d+(?:\.\d{1,6})?$/).test(text)) fail('money_format');
  const negative = text.startsWith('-');
  const [whole, fraction = ''] = (negative ? text.slice(1) : text).split('.');
  const amount = BigInt(whole) * SCALE + BigInt(fraction.padEnd(6, '0'));
  if (amount > MAX_MONEY) fail('money_out_of_range');
  return ((negative ? -1n : 1n) * amount).toString();
}

export function microToCny(value) {
  if (value === null || value === undefined || !/^-?\d+$/.test(String(value))) return '';
  const amount = BigInt(value);
  const absolute = amount < 0n ? -amount : amount;
  const fraction = (absolute % SCALE).toString().padStart(6, '0').replace(/0+$/, '').padEnd(2, '0');
  return `${amount < 0n ? '-' : ''}${absolute / SCALE}.${fraction}`;
}

export function formatCny(value) {
  const text = microToCny(value);
  if (!text) return '—';
  const [whole, fraction] = text.split('.');
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${fraction}`;
}

/** @param {Record<string, string> | null} current */
export function budgetAmounts(daily, monthly, current = null) {
  const daily_budget_micro = cnyToMicro(daily);
  const monthly_budget_micro = cnyToMicro(monthly);
  if (BigInt(daily_budget_micro) > BigInt(monthly_budget_micro)) fail('daily_exceeds_monthly');
  if (current && (BigInt(daily_budget_micro) > BigInt(current.daily_budget_micro) ||
    BigInt(monthly_budget_micro) > BigInt(current.monthly_budget_micro))) fail('budget_can_only_shrink');
  return { daily_budget_micro, monthly_budget_micro };
}

export function currencyError(error, t) {
  switch (error?.code) {
    case 'money_format': return t('请输入有效的 CNY 金额，最多六位小数。', 'Enter a valid CNY amount with up to six decimal places.');
    case 'money_out_of_range': return t('金额超出支持范围。', 'The amount exceeds the supported range.');
    case 'daily_exceeds_monthly': return t('每日预算不能高于每月预算。', 'The daily budget cannot exceed the monthly budget.');
    case 'budget_can_only_shrink': return t('预算不能高于当前上限。如需上调，请联系平台管理员；增加余额不会自动提高预算。', 'Budgets cannot exceed the current limits. Ask a platform administrator to raise them; adding credit does not raise budgets automatically.');
    case 'budget_exceeds_organization': return t('Key 预算不能高于组织预算。', 'Key budgets cannot exceed workspace budgets.');
    case 'revision_conflict': return t('预算已被更新，请刷新后重新填写。', 'The budget has changed. Refresh before editing again.');
    default: return '';
  }
}
